import { useUserIdQuery } from "@shared/data/queries/UserIdQuery/UserId.query";
import { OAuthLandingPage } from "@unauthenticated/oauth/components/OAuthOnboardingFlow/OAuthLandingStep/OAuthLandingPage/OAuthLandingPage";
import { SkeletonOAuthLandingPage } from "@unauthenticated/oauth/components/OAuthOnboardingFlow/OAuthLandingStep/OAuthLandingPage/SkeletonOAuthLandingPage";

import { OAuthStep } from "../oauthStep";

interface Props {
  target?: string;
  ssoOrigin?: string;
  isOidcSignUp?: boolean;
  onUpdateCurrentStep: (step: OAuthStep) => void;
}

const OAuthLandingStep = ({ onUpdateCurrentStep, ssoOrigin, isOidcSignUp, target }: Props) => {
  const { data: userQueryData, loading: userQueryLoading } = useUserIdQuery({
    fetchPolicy: "network-only",
  });

  if (userQueryLoading && !userQueryData) {
    return ssoOrigin || target ? null : <SkeletonOAuthLandingPage />;
  }

  if (userQueryData?.viewer) {
    if (ssoOrigin === "signin") {
      onUpdateCurrentStep(OAuthStep.AUTHORIZATION);
    } else if (ssoOrigin === "signup") {
      // OIDC sign-up skips the prac onboarding steps and completes the OIDC
      // handshake immediately (mirrors the OIDC form-submit success path).
      onUpdateCurrentStep(isOidcSignUp ? OAuthStep.AUTHORIZATION : OAuthStep.CERTIFICATION);
    }
  } else if (!userQueryLoading) {
    if (ssoOrigin === "signin" || target === "signin") {
      onUpdateCurrentStep(OAuthStep.SIGN_IN);
    } else if (ssoOrigin === "signup") {
      // A failed OIDC SSO sign-up returns here without a session; keep the user
      // on the OIDC step so the SSO error renders in context.
      onUpdateCurrentStep(isOidcSignUp ? OAuthStep.OIDC_SIGN_UP : OAuthStep.SIGN_UP);
    }
  }

  return <OAuthLandingPage onUpdateCurrentStep={onUpdateCurrentStep} />;
};

export { OAuthLandingStep };
